/*
 * Calls to the posh backend 
 */

require('es6-promise').polyfill();
require('isomorphic-fetch');


// eslint-disable-next-line
import util from 'util';
// eslint-disable-next-line

/* Default to logging any errors */
export let defaultErrorHandler = (error, status, content) => {
  util.log(error)
};


/* Function to get identity key */
export let sessionKey = () => {
  return('');
}

/* 
 * Set an error handler and a function to get the session key
 */
export function setup(errorHandler,
                      getSessionKey) {
  defaultErrorHandler = errorHandler;
  sessionKey = getSessionKey;
}


/*
 * Posh base URL
 */
export function BaseUrl() {
  /* Allows for React dev server on port 3000 */
  if (window.location.port === "3000") {
    return (window.location.protocol + '//' + window.location.hostname + "/portalApi");    
  } else {
    return (window.location.origin + "/portalApi");
  }
}


/*
 * Web socket URL
 */
export function WebSocket() {
  let url = BaseUrl();
  return("wss://" + url.substring(8) + "/update");
}

/*
 * Make an HTML form an object
 */
export function makeForm(formObject) 
{
  let form = '';
  let keyNames = Object.keys(formObject);
  let pos = 0;
  for (let i=0 ; i < keyNames.length; i++) {
    if (typeof(formObject[keyNames[i]]) === 'undefined') {
      continue;
    }
    if (pos>0) {
      form += '&';
    }
    pos++;
    if (formObject[keyNames[i]] instanceof Date) {
      form += keyNames[i] + '=' + encodeURIComponent(formObject[keyNames[i]].toISOString());
    } else {
      form += keyNames[i] + '=' + encodeURIComponent(formObject[keyNames[i]]);
    }
  }
  return(form);
}

/*
 * Make a Stringified JSON representation - useful for posting application/json
 */
export function stringifyJson(formObject) {
  if (formObject === undefined || formObject === null) {
    return null;
  }
  return JSON.stringify(formObject);
}

/*
 * Make a URL with query parameters
 */
export function makeQuery(baseUrl, queryParameters) 
{
  if (typeof(queryParameters) !== 'object' ||
      Object.keys(queryParameters).length === 0) {
    return(baseUrl);
  }
  let url = baseUrl;
  let keyNames = Object.keys(queryParameters);
  let pos = 0;
  for (let i=0 ; i < keyNames.length; i++) {
    if (typeof(queryParameters[keyNames[i]]) === 'undefined') {
      continue;
    }
    if (pos===0) {
      url += '?';
    } else {
      url += '&';
    }
    pos++;
    if (queryParameters[keyNames[i]] instanceof Date) {
      url += keyNames[i] + '=' + encodeURIComponent(queryParameters[keyNames[i]].toISOString());
    } else {
      url += keyNames[i] + '=' + encodeURIComponent(queryParameters[keyNames[i]]);
    }
  }
  return(url);
}

/*
 * Used by call() to get the right type content
 */
function getContent(response) {
  let contentType = response.headers.get('Content-Type');
  if (contentType === 'application/json') {
    return(response.json());
  }
  return(response.text());
}

/*
 * Make a call to the API
 */
export function call(url, 
                     parameters, 
                     successHandler,
                     errorHandler) {
  
  if (!parameters.headers) {
    parameters.headers={};
  }

  if (!parameters.headers['Authorization']) {
    parameters.headers['Authorization'] = 'Bearer ' + sessionKey();
  }
  
  if (parameters.method === 'post' && !parameters.headers['Content-Type']) {
    parameters.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
  }

  url = BaseUrl() + url;

  fetch(url, parameters)
    .then(function (response) {
      getContent(response).then((content) => {
        if (response.ok) {
          if (typeof(successHandler) === 'function') {
            successHandler(content, response.status);
          }
        } else {
          let poshError = response.headers.get('X-PORTAL-ERROR');
          if (poshError) {
            if (typeof(errorHandler) === 'function') {
              errorHandler(poshError, response.status, content);
            } else {
              defaultErrorHandler(poshError, response.status, content);
            }
          } else {
            if (typeof(errorHandler) === 'function') {
              errorHandler(response.statusText, response.status, content);
            } else {
              defaultErrorHandler(response.statusText, response.status, content, );
            }
          }
        }
      })
    }).catch(function(error) {
      if (typeof(errorHandler) === 'function') {
        errorHandler(error, -1, undefined);
      } else {
        defaultErrorHandler(error, -1, undefined);
      }
    });
}

